<template>
    <div>
        <!-- banner内容 -->
        <div :class="['banner-box', detail.bgClass ? detail.bgClass : 'bg1']">
            <img v-if="detail.bgClass === 'bg3'"
                 class="bg-img"
                 src="@/assets/imgs/whdh/10.png"
                 alt="">
            <div class="container">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item >历史遗存</el-breadcrumb-item>
                </el-breadcrumb>
                <h3 class="font-style-s">
                    <img src="@/assets/imgs/whdh/1@2x.png" alt="">
                    历史遗存
                    <img src="@/assets/imgs/whdh/2@2x.png" alt="">
                </h3>
                <!-- 内容 -->
                <div class="banner-title">
                    <div v-for="(val,i) in meanLists"
                         :key="i"
                         :class="[detail.name === val.name && 'active']"
                         @click="hanldeMean(val)">{{val.name}}</div>
                </div>
                <div class="gap-line"></div>
                <h2>前言</h2>
                <p style="text-indent: 2em;">{{detail.text}}</p>
            </div>
        </div>


        <!-- 位置 -->
        <div v-show='detail.name=== "物质遗存"'>
            <map-component ></map-component>
        </div>
        <!-- 道教名山 -->
        <div v-show='detail.name=== "祖山宝山"' class="ds-box">
            <div class="bs-item">
                <div class="type-box">
                    <el-image 
                        class="img" 
                        src="/image/culture/type/type1.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type1.png']"/>
                </div>
                <div class="content-box">
                    <el-image 
                        class="img" 
                        src="/image/culture/type/type1-1.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type1-1.png']"/>
                    <el-image 
                        class="img" 
                        src="/image/culture/type/type1-2.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type1-2.png']"/>
                   
                </div>
            </div>
            <div class="bs-item">
                <div class="type-box">
                    <el-image 
                        class="img" 
                        src="/image/culture/type/type2.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type2.png']"/>
                </div>
                <div class="content-box">
                    <div >
                        <el-image 
                            class="img" 
                            src="/image/culture/type/type2-1.png" 
                            mode="aspectFit" 
                            :preview-src-list="['/image/culture/type/type2-1.png']"/>
                        <el-image 
                            class="img" 
                            src="/image/culture/type/type2-2.png" 
                            mode="aspectFit" 
                            :preview-src-list="['/image/culture/type/type2-2.png']"/>
                        <br>
                        <el-image 
                            class="img2 img" 
                            src="/image/culture/type/type2-3.png" 
                            mode="aspectFit" 
                            :preview-src-list="['/image/culture/type/type2-3.png']"/>
                    </div>
                    <el-image 
                        class="img2 img" 
                        src="/image/culture/type/type2-4.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type2-4.png']"/>
                </div>
            </div>
            <div class="bs-item">
                <div class="type-box">
                    <el-image 
                        src="/image/culture/type/type3.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type3.png']"/>
                </div>
                <div class="content-box">
                    <el-image 
                        src="/image/culture/type/type3-1.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type3-1.png']"/>
                    <el-image 
                        src="/image/culture/type/type3-2.png" 
                        mode="aspectFit" 
                        :preview-src-list="['/image/culture/type/type3-2.png']"/>
                </div>
            </div>
        </div>

        <!-- 庙会庆典 -->
        <div v-show='detail.name=== "非物质文化遗存"' class="container qd-box">
            <ul>
                <li v-for="(item, index) in list3" :key="index" @click="goDetail(item)">
                    <img class="list-img" :src="item.picUrl" alt="">
                    <div class="texts">
                        <h5>{{item.title}}</h5>
                        <!-- <div class="date-time">
                            <label for="">
                                {{item.label}}
                            </label>
                        </div> -->
                        <p class="line-clamp3">{{item.introduction || '暂无描述~'}}</p>
                        <img class="more"  src="@/assets/imgs/more@3x.png" alt="">
                    </div>
                </li>
            </ul>
            <el-pagination
                v-if="total>10"
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handlePageChange"
                :current-page="page"
                :total="total"
                :page-size="10">
            </el-pagination>
        </div>
    </div>
</template>
<script setup>
import Header from '@/components/header.vue';
import Dialog from '@/components/dialog.vue';
import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import mapComponent from '@/components/mapComponent.vue';
import { articleLists } from '@/api/index';
const route = useRoute();
const router = useRouter();

const lists = ref([
    { 'name': '宝山上庵通天堂', 'desc': '（双圣亭堂）', text: `俗称“大圣祖庙”。位于宝山上庵南天门，与南天门建筑背对背依山势而筑。坐东南向西北，建筑面积约18平方米。堂内以墓式供俸“齐天大圣”和“通天大圣”。墓冢呈八字形，宽2.9米、深1.3米。墓首(墓顶石)呈屋脊状，中央雕刻葫芦“脊刹”,两端“脊吻”呈鱼尾状上翘，长0.76米、高0.25米。墓台上并立两碑，间距0.18米。左碑宽0.3米、高0.8米、厚0.12米，荷叶帽碑顶，碑额浮雕授带、拂尘、法螺图案。碑文上方横刻“宝峰”二字，中间竖行阴刻“齐天大圣”,下端横刻“神位”,外框浮雕如意卷草纹装饰。右碑宽0.33米、高0.8米、厚0.11米，荷叶帽碑顶，碑额浮雕桃枝纹，碑文竖行阴刻“通天大圣”,下端横刻“神位”,外框浮雕如意卷草纹装饰。
据宝山寺大殿及南天门建筑纪年显示，该建筑修造年代至少不晚于明洪武二十四年(1391年)。` },
    { 'name': '曲村通天大圣祭坛', 'desc': '（县级文物保护单位）',
	        text: `位于元坑镇曲村村，元至正年间建。坐东向西，坛基已毁，地面散见坛基须弥座及石制构件。坛树一碑，碑面竖行阴刻“通天大圣”,通高1.81米、高1.36米、宽0.52米、厚0.14米，碑顶雕饰荷叶帽，帽高0.26米，碑文下端雕饰七瓣莲花纹，碑左表皮竖行阴刻：“三山长邑大匠张天赐造，本坊主缘张骏忠建’两行铭文。碑座呈梯形，上底宽0.63米、下底宽0.80米、高0.45米、厚约0.30米，阴刻框边装饰。
据清宣统《曲村张氏族谱》记载：“张骏忠，官拜朝散大夫··生元延祐甲子(1324)卒至正丙午(1366)享年四十三”推断，该祭坛建于元代至正年间。`
    },
    { 'name': '岐头通天大圣坛庙', 'desc': '（县级文物保护单位）',
        text: '位于岚下乡黄墩村，为前庙后坛式，木构前庙为明代建筑，后坛为元代建筑，坐东向西。亭，单开间带周栏，重檐歇山顶，抬梁式构架，斗拱造型优雅古朴。亭后部中央置神龛，祀通天大圣“白衣秀才”造型神像。庙后约1米为通天大圣祭坛。朝向与庙一致，依山而筑。由拜台、祭台和三通坛碑组成。左碑碑额断损，碑面残存竖行阴刻线条勾勒“山黄石公”,疑前缺“开”字。通高0.75米、残碑高0.58米、宽0.26米、厚0.07米，阴刻框边装饰，距中碑约0.35米。中碑坚行框边阴刻“通天大圣”,通高1.26米、碑高0.98米、宽0.30米、厚0.08米，碑顶雕饰荷叶帽，阴刻框边装饰。右碑碑底断损，碑面残存竖行框边阴刻“本坛土地”,疑缺“神”字。通高0.66米、残碑高0.49米、宽0.26米、厚0.07米，阴刻框边装饰，与中碑间距约0.35米。'
    },
    { 'name': '云路通天大圣祭坛', 'desc': '（县级文物保护单位）'
        , text: '位于郑坊镇峰岭村，明代建筑。坐北向南，祭坛面阔25米，进深20米，占地面积约500平方米。依次由拜台、祭台、香炉及坛碑组成。碑高1.55米、宽0.47米、厚0.13米，碑文竖行阴刻“通天大圣仁济真君神位座”。'
    },
	    { 'name': '村头坪通天大圣祭坛群', 'desc': '（县级文物保护单位）', text: '位于岚下乡郭城村村头坪，洪武甲子年(1384年)建。坐西南向东北，占地面积约360平方米。祭坛上参差立有六通坛碑：1#碑竖行阴刻线条勾勒边框楷书“本坛土地”,碑顶断损，无座，残高1.01米，宽0.34米，厚约0.10米。2#碑竖行阴刻线条勾勒边框楷书“本坛土地正神”,通高1.26米，碑高0.90米，宽0.37米，厚约0.10米。3#碑竖行阴刻线条勾勒边框楷书“通天大圣”,通高1.58米，碑高1.20米，宽0.38米，厚不规则。4#碑竖行阴刻线条勾勒边框楷书“玉封通天大圣”,通高1.36厘米，碑高1米，宽0.37米，厚约0.10米。5#碑竖行阴刻线条勾勒边框楷书“通天大圣”,通高1.20米，碑高0.94米，宽0.46米，厚约0.20米，碑座正面自右向左竖行阴刻“信士口口，室谢口娘洪武甲子，喜舍成造”四行铭文。6#碑竖行阴刻线条勾制边框楷书“开山黄石尊公”,通高1.28米，碑高0.93米，宽0.36米，厚约0.14米，碑顶呈弧形。从形制和碑料所用石质不同分析，该祭坛六块坛碑应是由三组集中组成，其中，1#、3#为一组(缺黄公道者碑);2#、4#、6#为一组；5#为一组(缺本坛土地和黄公道者碑)。六碑和香台构成神坛，坛后是数株风水树茂盛，坛前为1989年原址重建的通天庙。' },
    { 'name': '谢坊头通天大圣祭坛', 'desc': '（县级文物保护单位）', text: '位于建西镇南山村，明代建筑。坐东南向西北。由拜台、祭台、香炉及三块坛碑组成，占地面积约30平方米。左碑阴刻“黄公道者”,通高1.03米、高0.76米、宽0.25米、厚0.10米；中碑阴刻“通天大圣”,通高1.09米、高0.83米、宽0.28米、厚0.10米：右碑阴刻“本坛土地”,通高1.0米、高0.76米、宽0.25米、厚0.08米，阴刻框边装饰。地面散落残碑两块，一块碑文“通天大圣”,另一块“黄公道者”残碑，仅见黄公两字。' },
    { 'name': '殷坑通天大圣祭坛', 'desc': '（县级文物保护单位）', text: '位于建西镇安下村，明代建筑，坐西北向东南，由拜台、祭台和三块坛碑组成，占地面积约30平方米。左碑竖行阳刻“黄公道者”,碑通高1.22米、高0.93米、宽0.33米、厚约0.09米、碑座高0.29米，距中碑约0.36米；中碑竖行阳刻“通天大圣”,碑通高1.33米、高1.03米、宽0.35米、厚约0.10米，碑座正面呈梯形，高0.3米、上底宽0.46米、下底宽0.5米、厚0.25米；右碑竖行阳刻“本坛土地”,通高1.21米、高0.93米、宽0.33米、厚0.1米、碑座高0.28米，距中碑0.4米。' },
    { 'name': '天台山通天大圣祭坛', 'desc': '（县级文物保护单位）', text: '位于洋口镇田坪村天台山，明代建筑。坐西北向东南，占地面积约29平方米。由路亭和四块坛碑组成，亭为当代重建。坛碑砂岩材质。左右两碑无字。前碑通高0.86米、碑高0.43米、宽0.33米、厚0.10米，碑文阴刻“檀那居士”;后碑无座，高1.09米、宽0.38米、厚0.10米，碑文阴刻“通天大圣仁济真君”,题款“万历十二年(1585年).…...”。' },
    { 'name': '郑坊通天大圣祭坛', 'desc': '（县级文物保护单位）',
        text: '位于郑坊镇郑坊村，明代建筑。坐西向东，面阔9米，进深12米，占地面积约108平方米。由拜台、祭台和两块坛碑组成(左碑石质，右碑砖质),左碑阴刻“通天大圣”,高0.7米、宽0.26米、厚0.07米，落款“明嘉靖.....。”;右碑阴刻“通天教主齐天大圣”,高0.45米、宽0.29米、厚0.07米。'
    },
    { 'name': '双舟尾通天大圣祭坛', 'desc': '（县级文物保护单位）',
        text: '位于埔上镇张墩村，明代建筑。坐西北向东南，占地面积约16平方米，由当代新筑拜台、祭台、香池和旧坛碑组成，坛碑花岗岩材质，圆弧顶，框边阴刻装饰，高0.93米、宽0.43米、厚0.13米，正面竖行阴刻：“通天大圣”,背面竖行繁体阴刻：“洪武戊寅(1398)十二月口杨银娘舍三尊”。'
    },
    { 'name': '范地通天大圣祭坛', 'desc': '（县级文物保护单位）',
        text: '位于大历镇立墩村，明代建筑。坐西向东。由拜台、祭台和六通坛碑组成。祭坛占地面积约为126平方米。前后相隔一米设两组各三通坛碑，前组三碑石质，中碑竖行框边阴刻“通天。落款“喜捨……张文……同室……”,碑通高1.1米、高0.9米、宽0.34米、厚0.18米；左碑竖行框边阴刻“黄公道者”,通高0.95米、高0.8米、厚0.15米，碑左侧阴刻“张……等”;右碑竖行框边阴刻“本坛土地”,通高0.95米、高0.8米、厚0.15米，碑右侧阴刻张文起、张景春等字。三碑间距0.7米。后排三碑为砖质，中碑竖行阴刻“通天大圣”,题款“天顺二年(1458)……”;右碑竖行阴刻“本坛土地”;左碑仅残存“道者”两字，残碑高0.6米、宽0.26米、厚0.08米，坛后为不规则毛石围筑挡墙。'
    },
    { 'name': '洋门通天大圣祭坛', 'desc': '（县级文物保护单位）', text: '位于大干镇武坊村，明代建筑。坐西北向东南。正对宝山南天门双圣享堂。占地面积约140平方米。前亭已毁，由拜台、祭台和三块坛碑组成，碑与碑座、碑帽连体，碑额雕饰荷叶帽。左碑竖行阴刻“黄公道者”,通高0.76米、高0.63米、宽0.31米、厚0.10米，碑左侧阴刻“饶琦舍”;中碑竖行阴刻“通天大圣”,通高0.86米、高0.75米、宽0.32米、厚0.10米，框边剔地装饰，碑右侧阴刻“饶荣长舍”;右碑竖行阴刻“本坛土地”,通高0.76米、高0.63米、宽0.32米、厚0.10米，碑右侧阴刻“张政成舍”。' }
]);
const dialog = ref(false);
const itemDetail = ref({});

const meanLists = ref([
    {
        name: '物质遗存',
        id: 1,
        bgClass: 'bg1',
        text: `闽台自古就有“山尊大圣、海祭妈祖”的传统民俗。大圣文化是古闽越及早期汉民族自然崇拜的历史遗存，是中华优秀传统文化和闽人智慧的代表性内容。在融合中国儒释道文化的过程中，逐渐形成了独具特色的文化内涵。
在顺昌，大圣文化可追溯至唐末五代，鼎盛于元明，至今已有千年历史。县域遍布宋元明清各时期大圣文化遗迹，目前，已发现祭坛、神位碑刻及庙堂120余处。其中，以“通天大圣”冠名登记在册的祭坛及祭坛遗址78处。
此次，我们精选30处冠名“通天大圣”代表性坛庙，作为大圣祖地实物佐证，通过照片及简介形式进行展示，旨在传承和发扬大圣祖地文化时代精神内涵，绘就两岸大圣文化学术交流与民间往来新画卷。`

    },
    {
        name: '祖山宝山',
        bgClass: 'bg2',
        id: 2,
        text: '国家级风景名胜区- -宝山，海拔1305米，自古就是八闽名山之一。宝山山林茂密，常年云雾缭绕，宛如仙境。拥有宝山寺大殿、南天门、双圣享堂、圣祖峰、孕圣仙石、五指山、水帘洞等珍贵历史遗存和《西游记》重要契合景观，被海内外信众共同尊拜为“大圣祖山”。'

    },
    {
        name: '非物质文化遗存',
        bgClass: 'bg3',
        id: 3,
        text: '顺昌大圣信俗文化历史悠久，在元坑、郑坊、大干、建西、岚下、高阳等乡镇的一些村庄，至今还保留着定期举办大圣生日庙会、生日庆典等民俗活动。'

    }
]);
const detail = ref(meanLists.value[0]);
const list3 = ref([]);
const total = ref([]);
const page = ref(1);
const getList4 = () => {
    articleLists({
        pageNo: page.value,
        pageSize: 10,
        categoryId: 12
    }).then(({ data }) => {
        const _data = data?.list || [];

        list3.value = _data;
        total.value = data?.total || 0;
    });
};

onMounted(() => {
    detail.value = meanLists.value[route.query?.type - 1 || 0];
});

const goDetail = (item) => {
    router.push('/culturalTourDetail?id=' + item.id);
};

function handleItem (val) {
    itemDetail.value = val;
    dialog.value = true;
    console.log(val);
}

function handleClickItem (val) {
    itemDetail.value = val;
    console.log(val);
}

function hanldeMean (val) {
    detail.value = val;
    if (val.id === 3) {
        getList4();
    }
}

function playVoice () {
    console.log(itemDetail.value);
    // 播放语音
    // const audio = new Audio(itemDetail.value.voice)
    // audio.play()
}
const handlePageChange = (val) => {
    page.value = val;
    getList4();
};
</script>
<style lang="scss" scoped>
.container{
    position: relative;
    z-index: 9;
}
.banner-box{
    // background: url('~@/assets/imgs/1@2x.png') no-repeat;
    height: 913px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 185px;
    box-sizing: border-box;
    position: relative;
    margin-top: -175px;
    &.bg1{
         background-image: url('~@/assets/imgs/3@3x.png');
    }
    &.bg2{
         background-image: url('~@/assets/imgs/whdh/3.png');
    }
    &.bg3{
         background-image: url('~@/assets/imgs/whdh/20.png');
    }
    .bg-img{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        z-index: 2;
    }
    ::v-deep {
        .el-breadcrumb__inner{
            color: #fff;
            font-size: 14px;
        }
        .el-breadcrumb__separator{
            font-size: 10px;
        }

    }
    h3{
        font-weight:700;
        color:#ffffff;
        font-size:33px;
        text-align:center;
        margin-top: 64px;
        img{
            width: 23.05px;
            height: 37px;
            vertical-align: middle;
        }
    }
    .banner-title{
        margin-top: 44px;
        display: flex;
        gap:32px;
        justify-content: center;
        > div{
            width: 229.9px;
            height: 56px;
            color:#4e4e4e;
            font-size:14px;
            background: url('~@/assets/imgs/unchecked.png') no-repeat;
            background-size: cover;
            text-align: center;
            line-height: 60px;
            cursor: pointer;
        }
        .active{
            background: url('~@/assets/imgs/checked@3x.png') no-repeat;
            background-size: cover;
            color: #fff;
        }
    }
    .gap-line{
        width:1243px;
        height:0px;
        border:1px solid;
        border-color:#cbcbcb;
        margin-top: 32px;
        margin-bottom: 44px;
    }
    h2{
        font-weight:700;
        color:#ececec;
        font-size:30px;
        text-align:center;
        margin-bottom: 44px;
    }
    p{
        width:805px;
        height:196px;
        line-height:36px;
        font-family:Source Han Sans CN;
        color:#ffffff;
        font-size:16px;
        margin: auto;
    }
}
.map{
    padding-left: 166px;
   background:#ececec;
   display: flex;
}
.map-box{
    width: 901.12px;
    height: 839px;
    background: url('~@/assets/imgs/whdh/3@2x.png') no-repeat;
    background-size: contain;
    position: relative;

    .map-tag{
        text-align: center;
        position: absolute;
        opacity: 0;
        transition: all 0.3s;
        cursor: pointer;
        span{
            padding: 10px;
            background: #a26e3f;
            border-radius: 9px;
            font-weight:700;
            color:#ffffff;
            font-size:13px;
            text-align:center;
            margin: auto;
        }
        i{
            width: 0px;
            height: 108px;
            border: 2px solid;
            border-color: #d4776c;
            display: block;
            margin: auto;
        }
    }
    .showOpacity{
        opacity: 1 !important;
    }
    .pos0{
        top:300px;
        left: 150px;
    }
    .pos1{
        top:450px;
        left: 200px;
    }
    .pos2{
        right:200px;
        top: 180px;
    }
    .pos3{
        top:490px;
        left: 200px;
    }
    .pos4{
        right:250px;
        top: 220px;
    }
    .pos5{
        right:290px;
        top: 420px;
    }
    .pos6{
        right:285px;
        top: 375px;
    }
    .pos7{
        right:355px;
        top: 410px;
    }
    .pos8{
        top:520px;
        left: 180px;
    }
    .pos9{
        top:300px;
        left: 235px;
    }
    .pos10{
        right:220px;
        top: 305px;
    }
    .pos11{
        top:280px;
        left: 90px;
    }
}
.map-text{
    width: 538px;
    height: 486px;
    background: #885d36;
    padding: 24px 18px;
    box-sizing: border-box;
    margin-top: 122px;
    margin-left: 55px;
    overflow: hidden;
    h4{
        text-align: center;
        margin-bottom: 35px;
        font-weight:700;
        color:#ffffff;
        font-size:24px;
        text-align:center;
    }
    ul{
        display: grid;
        grid-template-columns: 165px 165px 165px;
        gap: 6px;
        li{
            font-weight:700;
            color:#ffffff;
            font-size:16px;
            text-align:center;
            height:82px;
            background:#a26e3f;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            cursor: pointer;
            &.active{
                background:#654425 !important;
            }
            .desc{
                color:rgba(#ffffff,.5);
                font-size:12px;
                text-align:center;
            }
        }
    }
}
.tips-tit{
    height: 330px;
    background: #654425;
    width: 100%;
    position: relative;
    .l-icon{
        opacity: 70%;
        width: 26px;
        height: 24.86px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .r-icon{
        opacity: 70%;
        width: 26px;
        height: 24.86px;
        position: absolute;
        top: 0;
        right: 0;
    }
    .voice-icon{
        width: 76px;
        height: 76px;
        position: absolute;
        top: 300px;
        right: 17px;
    }
}
.tips-tit-con{
    padding-top: 53px;
    .img-desc{
        width: 217px;
        height: 163px;
        border: 2px solid;
        border-color: #bc7d4b;
        display: block;
        margin: 0 auto;
    }
    h5{
        font-weight:700;
        color:#ffffff;
        font-size:24px;
        text-align:center;
        margin-top: 23px;
        img{
            vertical-align: middle;
            width: 17.05px;
            height: 27px;
        }
    }
    .desc{
        font-weight:700;
        color:#ffffff;
        opacity: 0.5;
        font-size:12px;
        margin-top: 6px;
        text-align: center;
    }
}
.tip-content{
    padding: 50px;
    color:#535353;
    font-size:13px;
}
.tip-btn{
    width: 229.9px;
    height: 56px;
    display: block;
    margin: 8px auto;
}
.close{
    color:#ffffff;
    font-size:16px;
    text-align:center;
    position: absolute;
    bottom: -50px;
    left: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
}
::v-deep .el-dialog__body{
    padding: 0 !important;
    width: 100%;
}
.ds-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .bs-item {
        width: 1449px;
        height: 443px;
        margin-top: 50px;
        display: flex;
        background-color: #d4d9df;
        .type-box{
            width: 323px;
            height: 446px;
            flex-shrink: 0;
            position: relative;
            top: -20px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .content-box{
            flex: 1;
            display: flex;
            padding: 53px;
            gap: 20px;
            div{
                flex-shrink: 0;
                width: 537px;
                .img{
                    width: 49%;
                    height: 146px;
                    object-fit: cover;
                    &:first-child{
                        margin-right: 5px;
                    }
                }
                .img2 {
                    width: 100%;
                    height: 188px;
                }
            }
            .img{
                width: 50%;
            }
        }
    }
    .ds-imgs{
        display: flex;
        gap:60px;
        position: relative;
        top: -60px;
        img{
            width: 338px;
            height: 446px;
        }
    }
    .ds-content{
        background: url('~@/assets/imgs/ds/7@2x.png')no-repeat;
        background-size: 100% 100%;
        text-align: center;
        h5{
            font-weight:700;
            color:#202020;
            font-size:19px;
            margin-bottom: 5px;
        }
        label{
            color:#4b4b4b;
            font-size:12px;
            text-align:center;
            margin:0 auto 12px;
        }
        .dotted-line{
            opacity: 50%;
            width: 532px;
            height: 0px;
            border: 1px solid;
            border-color: #707070;
             margin:0 auto 12px;
        }
        p{
            color:#4b4b4b;
            font-size:14px;
            text-align:center;
            width:551px;
            height:34px;
            margin: auto;
        }

        img{
            width: 763px;
            height: 424px;
        }
    }
}
.qd-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;

    .qd-li{
        width: 337px;
        height: 382px;
        background: #ffffff;
        padding: 22px 36px;
        box-sizing: border-box;
        text-align: center;
        img{
            width:125px;
            height:125px;
            // box-shadow:0px 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 50%;
            margin-bottom: 11px;
        }

        h4{
            font-weight:700;
            color:#555555;
            font-size:27px;
            text-align:center;
        }
        i{
            font-style: normal;
            display: block;
            color:#555555;
            font-size:17px;
            text-align:center;
        }
        p{
            color:#555555;
            font-size:13px;
            text-align: left;
            margin-top: 37px;
        }
    }
    ul{
        width: 100%;
        li{
            display: flex;
            background: #fff;
            padding: 15px 18px;
            margin-bottom: 20px;
            cursor: pointer;

            .list-img{
                width: 191px;
                height: 261px;
                object-fit: cover;
            }
            .texts{
                padding:17px 32px;
                flex: 1;
                box-sizing: border-box;
                 position: relative;
                 .date-time{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;
                    .author{
                        color:#848484;
                        font-size:18px;
                    }
                 }
                h5{
                    color:#232323;
                    font-size:24px;
                    margin-bottom: 20px;
                }
                label{
                    color:#848484;
                    font-size:18px;
                    display: block;
                }
                p{
                    color:#848484;
                    font-size:18px;
                    margin-top: 15px;
                }
                a{
                    width: 87px;
                    height: 26px;
                    border: 1px solid;
                    border-color: #686868;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
                .more{
                      width: 87px;
                    height: 26px;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
            }
        }
    }
}
</style>
